module.exports = "<svg viewBox=\"0 0 14 15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.7 13.13c.4.428.4 1.114.002 1.54-.198.214-.465.33-.743.33-.28 0-.546-.116-.745-.328L7 9.07l-5.215 5.6c-.197.214-.465.33-.743.33-.278 0-.545-.116-.743-.328-.4-.428-.4-1.114 0-1.54L5.54 7.5.3 1.87C-.1 1.442-.1.756.3.33c.407-.44 1.077-.44 1.485 0L7 5.93l5.215-5.6c.408-.44 1.078-.44 1.487 0 .397.427.397 1.112 0 1.54L8.46 7.5l5.24 5.63z\" fill-rule=\"nonzero\" fill=\"none\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/close.svg
// module id = DHpE
// module chunks = 89